import type {
  ClientPayment,
  CreateClientPaymentInput,
  UpdateClientPaymentInput,
  EventClientLedger,
  ClientReceivablesReport,
} from '@peles/shared';
import { apiClient } from './client';

export async function listClientPaymentsByEvent(eventId: string): Promise<ClientPayment[]> {
  const { data } = await apiClient.get<ClientPayment[]>('/client-payments', {
    params: { eventId },
  });
  return data;
}

export async function getClientPayment(id: string): Promise<ClientPayment> {
  const { data } = await apiClient.get<ClientPayment>(`/client-payments/${id}`);
  return data;
}

export async function createClientPayment(input: CreateClientPaymentInput): Promise<ClientPayment> {
  const { data } = await apiClient.post<ClientPayment>('/client-payments', input);
  return data;
}

export async function updateClientPayment(
  id: string,
  updates: UpdateClientPaymentInput,
): Promise<ClientPayment> {
  const { data } = await apiClient.patch<ClientPayment>(`/client-payments/${id}`, updates);
  return data;
}

export async function deleteClientPayment(id: string): Promise<void> {
  await apiClient.delete(`/client-payments/${id}`);
}

export async function getEventClientLedger(eventId: string): Promise<EventClientLedger> {
  const { data } = await apiClient.get<EventClientLedger>(`/client-payments/ledger/${eventId}`);
  return data;
}

export async function getClientReceivables(): Promise<ClientReceivablesReport> {
  const { data } = await apiClient.get<ClientReceivablesReport>('/client-payments/receivables');
  return data;
}
